import React, { useEffect, useState } from 'react';
import {Box,Typography,Button,TextField,MenuItem,Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Navbar from '../Navbar/Navbar';
import PedidoExpressDetalleModal from './PedidoExpressDetalleModal';
import { useCarrito } from '../context/CarritoContext';
import { useMediaQuery } from '@mui/material';
import CancelarModalExpress from './CanncelarModalExpress';
import EstatusModalExpress from './EstatusModalExpress';

const PedidosExpress = () => {
  const [pedidos, setPedidos] = useState([]);
  const nombreCliente = localStorage.getItem('Nombre');
  const { rol } = useCarrito();
  const [modalOpen, setModalOpen] = useState(false);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [modalEstatusOpen, setModalEstatusOpen] = useState(false);
  const [pedidoParaEstatus, setPedidoParaEstatus] = useState(null);
  const [pedidoCancelar, SetPedidoCancelar] = useState(null);
  const [modalCancelar, setModalCancelar] = useState(false);
  
  const isMobile = useMediaQuery('(max-width:600px)');

  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroFecha, setFiltroFecha] = useState('');
  const [filtroEstatus, setFiltroEstatus] = useState('');
  const [filtroFacturacion, setFiltroFacturacion] = useState('');

  const abrirModal = (idPedido) => {
    setPedidoSeleccionado(idPedido);
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setModalOpen(false);
    setPedidoSeleccionado(null);
  };

  const abrirModalEstatus = (pedido) => {
    setPedidoParaEstatus(pedido);
    setModalEstatusOpen(true);
  };

  const cerrarModalEstatus = () => {
    setModalEstatusOpen(false);
    setPedidoParaEstatus(null);
  };

  const abrirModalCancelar = (pedido) => {
    SetPedidoCancelar(pedido);
    setModalCancelar(true);
  };

  const cerrarModalCancelar = () => {
    SetPedidoCancelar(false);
    setModalCancelar(null);
  };

  const recargarPedidos = async () => {
    try {
      const response = await fetch(`https://bibliotecadlago.com/php/lista_pedidosexpress.php`);
      const data = await response.json();
      if (data.success) {
        setPedidos(data.data);
      }
    } catch (error) {
      console.error('Error al recargar pedidos:', error);
    }
  };

  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const response = await fetch(`https://bibliotecadlago.com/php/lista_pedidosexpress.php`);
        const data = await response.json();
        if (data.success) {
          setPedidos(data.data);
        } else {
          console.error('Error al obtener pedidos');
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };
    fetchPedidos();

    const intervalo = setInterval(() => {
      fetchPedidos(); 
    }, 600000); // 600000 ms = 10 minutos
  
    return () => clearInterval(intervalo);
  }, []);

  const columnas = [
    { field: 'IdPedidoExpress', headerName: 'ID', width:  isMobile ? 40 : 40 },
    { field: 'Nombre', headerName: 'Cliente', width:  isMobile ? 120 : 150 },
    { field: 'Fecha', headerName: 'Fecha', width: isMobile ? 110 : 150 },
    { field: 'DireccionEntregar', headerName: 'Direccion', width: isMobile ? 110 : 170 },
    { field: 'Estatus', headerName: 'Estatus', width: 100 },
    { field: 'Total', headerName: 'Total', width: 60 },
    { field: 'NumFactura', headerName: 'Factura', width: 80 },
    ...(rol !== 'Cliente' && !isMobile
      ? [
        { field: 'FechaCambio', headerName: 'Cambio de estatus', width: 160 },
        { field: 'NombreCambio', headerName: 'Encargado del cambio', width: 170 },
      ]
      : []),
    {
      field: 'acciones',
      headerName: 'Acciones',
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            size="small"
            onClick={() => abrirModal(params.row.IdPedidoExpress)}
            sx={{
              marginRight: 1,
              backgroundColor: '#242c59',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#1b2247',
              },
            }}
          >
            Ver Detalles
          </Button>
          {rol !== 'Cliente' && (
            <Button
              variant="contained"
              size="small"
              onClick={() => abrirModalEstatus(params.row)}
              sx={{
                backgroundColor: '#242c59',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#1b2247',
                },
              }}
            >
              Cambiar Estatus
            </Button>
          )}
          {rol === 'Cliente' && (
            <Button
              variant="contained"
              size="small"
              onClick={() => abrirModalCancelar(params.row)}
              sx={{
                backgroundColor: '#ff0000ff',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#d10707ff',
                },
              }}
            >
              Cancelar
            </Button>
          )}
        </>
      ),
    },
  ];

  const filasFiltradas = pedidos
    .filter((pedido) => rol !== 'Cliente' || pedido.Nombre === nombreCliente)
    .filter((pedido) =>
      rol !== 'Cliente'
        ? (!filtroCliente || pedido.Nombre.toLowerCase().includes(filtroCliente.toLowerCase())) &&
        (!filtroFecha || pedido.Fecha.includes(filtroFecha)) &&
        (!filtroEstatus || pedido.Estatus?.toLowerCase() === filtroEstatus.toLowerCase()) &&
        (!filtroFacturacion || (pedido.Facturacion ?? '').toLowerCase().includes(filtroFacturacion.toLowerCase()))
        : true
    )
    .map((pedido) => ({ id: pedido.IdPedidoExpress, ...pedido }));

  return (
    <>
      <Navbar />
      <Box p={4}>
        <Typography variant="h4" gutterBottom sx={{ color: '#cf1316', fontWeight: 'bold' }}>
          Lista de Pedidos
        </Typography>

        {rol !== 'Cliente' && (
          <Box mb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Filtrar por Cliente"
                  value={filtroCliente}
                  onChange={(e) => setFiltroCliente(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Filtrar por Fecha"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={filtroFecha}
                  onChange={(e) => setFiltroFecha(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Filtrar por Estatus"
                  select
                  value={filtroEstatus}
                  onChange={(e) => setFiltroEstatus(e.target.value)}
                  sx={{ minWidth: 180 }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="Solicitado">Solicitado</MenuItem>
                  <MenuItem value="En Facturación">En Facturación</MenuItem>
                  <MenuItem value="Facturado">Facturado</MenuItem>
                  <MenuItem value="Cancelado">Cancelado</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  fullWidth
                  label="Filtrar por Facturación"
                  select
                  value={filtroFacturacion}
                  onChange={(e) => setFiltroFacturacion(e.target.value)}
                  sx={{ minWidth: 200 }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="MAYOREO AGUASCALIENTES">Mayoreo Aguascalientes</MenuItem>
                  <MenuItem value="MAYOREO JALISCO">Mayoreo Jalisco</MenuItem>
                  <MenuItem value="MAYOREO PUERTO VALLARTA">Mayoreo Puerto Vallarta</MenuItem>
                  <MenuItem value="MAYOREO COLIMA">Mayoreo Colima</MenuItem>
                  <MenuItem value="MAYOREO ZACATECAS">Mayoreo Zacatecas</MenuItem>
                  <MenuItem value="MAYOREO DURANGO">Mayoreo Durango</MenuItem>
                  <MenuItem value="MAYOREO LEON">Mayoreo León</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>
        )}

        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={filasFiltradas}
            columns={columnas}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </Box>

        {pedidoSeleccionado && (
          <PedidoExpressDetalleModal
            open={modalOpen}
            onClose={cerrarModal}
            idPedido={pedidoSeleccionado}
          />
        )}
        {pedidoParaEstatus && (
          <EstatusModalExpress
            open={modalEstatusOpen}
            onClose={cerrarModalEstatus}
            idPedido={pedidoParaEstatus.IdPedidoExpress}
            estatusActual={pedidoParaEstatus.Estatus}
            onActualizar={() => {
              cerrarModalEstatus();
              recargarPedidos();
            }}
          />
        )}
        {pedidoCancelar && (
          <CancelarModalExpress
            open={modalCancelar}
            onClose={cerrarModalCancelar}
            idPedido={pedidoCancelar.IdPedidoExpress}
            onActualizar={() => {
              cerrarModalEstatus();
              recargarPedidos();
            }}
          />
        )}
      </Box>
    </>
  );
};

export default PedidosExpress;
